export const vehicleDefects = [
  { required: true, key: "battery_security", id: "1", title: "Battery Security", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "spray_suppression", id: "2", title: "Spray Suppression", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "registration_plates", id: "3", title: "Registration Plates", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "seat_belt", id: "4", title: "Seat Belt", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "warning_lights", id: "5", title: "Warning Lights", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "wipers", id: "6", title: "Wipers", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "exhaust_smoke", id: "7", title: "Exhaust Smoke", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "reflectors", id: "8", title: "Reflectors, Markers and Lights", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "indicators", id: "9", title: "Indicators", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "adblue", id: "10", title: "Adblue", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "cab_steps", id: "11", title: "Cab Steps", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "fuel_leaks", id: "12", title: "Fuel Leaks", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "wheels_tyres_fixing", id: "13", title: "Wheels Tyres Fixing", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "steering", id: "14", title: "Steering", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "brakes", id: "15", title: "Brakes", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "air_build", id: "16", title: "Air Build", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "odometer", id: "17", title: "Odometer", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "tachograph", id: "18", title: "Tachograph", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "security_load", id: "19", title: "Security Load", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "mirrors", id: "21", title: "Mirrors", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "fit_to_drive", id: "22", title: "Fit to Drive", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "licence_visible", id: "23", title: "Licence Visible", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "glass_visibility", id: "24", title: "Glass Visibility", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "doors", id: "25", title: "Doors", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "first_aid_kit", id: "26", title: "First Aid Kit", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "passenger_seat_belt", id: "27", title: "Passenger Seat Belt", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "fire_extinguisher", id: "28", title: "Fire Extinguisher", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "tail_lift", id: "29", title: "Tail Lift", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "alternative_fuels", id: "30", title: "Alternative Fuels", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "horn", id: "44", title: "Horn", status: false, images: [], notes: '', not_road_worthy: false },

  { required: false, key: "brake_lines", id: "20", title: "Brake Lines", status: false, images: [], notes: '', not_road_worthy: false },

  { required: false, key: "body_condition", id: "31", title: "Body Condition", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "coupling_security", id: "32", title: "Coupling Security", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "electrical_connections", id: "33", title: "Electrical Connections", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "saloon_lighting", id: "34", title: "Saloon Lighting", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "heating", id: "35", title: "Heating", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "wheelchair", id: "36", title: "Wheelchair", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "communication_devices", id: "37", title: "Communication Devices", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "prominent_warning_signage", id: "38", title: "Prominent Warning Signage", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "side_under_run_protection", id: "39", title: "Side Under Run Protection", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "camera_system", id: "40", title: "Camera System", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "fresnel_lenses", id: "41", title: "Fresnel Lenses", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "high_voltage_emergency_cut_off_switch", id: "42", title: "High Voltage Emergency Cut Off Switch", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "adas", id: "43", title: "Adas", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "pumptruck", id: "45", title: "Pumptruck Working", status: false, images: [], notes: '', not_road_worthy: false },
  { required: true, key: "atlas", id: "46", title: "Atlas", status: false, images: [], notes: '', not_road_worthy: false },
];

export const vehicleDefectsReturnData = [
  { required: false, key: "battery_security", id: "1", title: "Battery Security", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "spray_suppression", id: "2", title: "Spray Suppression", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "registration_plates", id: "3", title: "Registration Plates", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "seat_belt", id: "4", title: "Seat Belt", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "warning_lights", id: "5", title: "Warning Lights", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "wipers", id: "6", title: "Wipers", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "exhaust_smoke", id: "7", title: "Exhaust Smoke", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "reflectors", id: "8", title: "Reflectors, Markers and Lights", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "indicators", id: "9", title: "Indicators", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "adblue", id: "10", title: "Adblue", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "cab_steps", id: "11", title: "Cab Steps", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "fuel_leaks", id: "12", title: "Fuel Leaks", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "wheels_tyres_fixing", id: "13", title: "Wheels Tyres Fixing", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "steering", id: "14", title: "Steering", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "brakes", id: "15", title: "Brakes", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "air_build", id: "16", title: "Air Build", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "odometer", id: "17", title: "Odometer", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "tachograph", id: "18", title: "Tachograph", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "security_load", id: "19", title: "Security Load", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "mirrors", id: "21", title: "Mirrors", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "fit_to_drive", id: "22", title: "Fit to Drive", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "licence_visible", id: "23", title: "Licence Visible", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "glass_visibility", id: "24", title: "Glass Visibility", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "doors", id: "25", title: "Doors", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "first_aid_kit", id: "26", title: "First Aid Kit", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "passenger_seat_belt", id: "27", title: "Passenger Seat Belt", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "fire_extinguisher", id: "28", title: "Fire Extinguisher", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "tail_lift", id: "29", title: "Tail Lift", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "alternative_fuels", id: "30", title: "Alternative Fuels", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "horn", id: "44", title: "Horn", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "brake_lines", id: "20", title: "Brake Lines", status: false, images: [], notes: '', not_road_worthy: false },


  { required: false, key: "body_condition", id: "31", title: "Body Condition", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "coupling_security", id: "32", title: "Coupling Security", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "electrical_connections", id: "33", title: "Electrical Connections", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "saloon_lighting", id: "34", title: "Saloon Lighting", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "heating", id: "35", title: "Heating", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "wheelchair", id: "36", title: "Wheelchair", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "communication_devices", id: "37", title: "Communication Devices", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "prominent_warning_signage", id: "38", title: "Prominent Warning Signage", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "side_under_run_protection", id: "39", title: "Side Under Run Protection", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "camera_system", id: "40", title: "Camera System", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "fresnel_lenses", id: "41", title: "Fresnel Lenses", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "high_voltage_emergency_cut_off_switch", id: "42", title: "High Voltage Emergency Cut Off Switch", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "adas", id: "43", title: "Adas", status: false, images: [], notes: '', not_road_worthy: false },

  { required: false, key: "pumptruck", id: "45", title: "Pumptruck Working", status: false, images: [], notes: '', not_road_worthy: false },
  { required: false, key: "atlas", id: "46", title: "Atlas", status: false, images: [], notes: '', not_road_worthy: false },

];

export const deliveryStatuses = [
  { id: 1, title: "Customer Over Ordered" },
  { id: 2, title: "Customer Returned" },
  { id: 3, title: "Damaged In Transit" },
  { id: 4, title: "Delivery Fee Discount" }, // set in case of postponed from tms-backend
  { id: 5, title: "Full Delivery Return" },
  { id: 6, title: "Invoice Error" },
  { id: 7, title: "Item Discount" },
  { id: 8, title: "Loading Error" },
  { id: 9, title: "Pricing Error" },
  { id: 10, title: "Short Dated" },
  { id: 11, title: "Shortage" },
  { id: 12, title: "Delivered" },
];

export const schedules = [
  { id: 1, title: "06:00" },
  { id: 2, title: "06:30" },
  { id: 3, title: "07:00" },
  { id: 4, title: "07:30" },
  { id: 5, title: "08:00" },
  { id: 6, title: "08:30" },
  { id: 7, title: "09:00" },
  { id: 8, title: "09:30" },
  { id: 9, title: "10:00" },
  { id: 10, title: "10:30" },
  { id: 11, title: "11:00" },
  { id: 12, title: "11:30" },
  { id: 13, title: "12:00" },
  { id: 14, title: "12:30" },
  { id: 15, title: "13:00" },
  { id: 16, title: "13:30" },
  { id: 17, title: "14:00" },
  { id: 18, title: "14:30" },
  { id: 19, title: "15:00" },
  { id: 20, title: "15:30" },
];

export const vehicleTypes = [
  {
    id: 1,
    title: "3.5 Tonnes",
    maxWeight: 900,
    maxPallets: 4,
    maxPalletWeight: 450,
    weightThreshold: 50,
  },
  {
    id: 2,
    title: "7.5 Tonnes",
    maxWeight: 3000,
    maxPallets: 7,
    maxPalletWeight: 650,
    weightThreshold: 50,
  },
  {
    id: 3,
    title: "16 Tonnes",
    maxWeight: 6000,
    maxPallets: 12,
    maxPalletWeight: 650,
    weightThreshold: 50,
  },
  {
    id: 4,
    title: "18 Tonnes",
    maxWeight: 7500,
    maxPallets: 14,
    maxPalletWeight: 650,
    weightThreshold: 50,
  },
];

export const cardTerminals = [
  { id: -1, title: "No Terminal" },
  { id: 1, title: "C1" },
  { id: 2, title: "C2" },
  { id: 3, title: "C3" },
  { id: 4, title: "C4" },
  { id: 5, title: "C5" },
  { id: 6, title: "C6" },
  { id: 7, title: "C7" },
  { id: 8, title: "C8" },
  { id: 9, title: "C9" },
  { id: 10, title: "C10" },
  { id: 11, title: "C11" },
  { id: 12, title: "C12" },
  { id: 13, title: "C13" },
  { id: 14, title: "C14" },
  { id: 15, title: "C15" },
  { id: 16, title: "C16" },
  { id: 17, title: "C17" },
  { id: 18, title: "C18" },
  { id: 19, title: "C19" },
  { id: 20, title: "C20" },
  { id: 21, title: "C21" },
  { id: 22, title: "C22" },
  { id: 23, title: "C23" },
  { id: 24, title: "C24" },
  { id: 25, title: "C25" },
  { id: 26, title: "C26" },
  { id: 27, title: "C27" },
  { id: 28, title: "C28" },
  { id: 29, title: "C29" },
  { id: 30, title: "C30" },
];

export const pumpTruckBatteries = [
  { id: 1, title: "PB1" },
  { id: 2, title: "PB2" },
  { id: 3, title: "PB3" },
  { id: 4, title: "PB4" },
  { id: 5, title: "PB5" },
  { id: 6, title: "PB6" },
  { id: 7, title: "PB7" },
  { id: 8, title: "PB8" },
  { id: 9, title: "PB9" },
  { id: 10, title: "PB10" },
  { id: 11, title: "PB11" },
  { id: 12, title: "PB12" },
  { id: 13, title: "PB13" },
  { id: 14, title: "PB14" },
  { id: 15, title: "PB15" },
  { id: 16, title: "PB16" },
  { id: 17, title: "PB17" },
  { id: 18, title: "PB18" },
  { id: 19, title: "PB19" },
  { id: 20, title: "PB20" },
  { id: 21, title: "PB21" },
  { id: 22, title: "PB22" },
  { id: 23, title: "PB23" },
  { id: 24, title: "PB24" },
  { id: 25, title: "PB25" },
  { id: 26, title: "PB26" },
  { id: 27, title: "PB27" },
  { id: 28, title: "PB28" },
  { id: 29, title: "PB29" },
  { id: 30, title: "PB30" },
];

export const allPumpTrucks = [
  { id: -1, title: "No Pump Truck" },
  { id: 1, title: "P1" },
  { id: 2, title: "P2" },
  { id: 3, title: "P3" },
  { id: 4, title: "P4" },
  { id: 5, title: "P5" },
  { id: 6, title: "P6" },
  { id: 7, title: "P7" },
  { id: 8, title: "P8" },
  { id: 9, title: "P9" },
  { id: 10, title: "P10" },
  { id: 11, title: "P11" },
  { id: 12, title: "P12" },
  { id: 13, title: "P13" },
  { id: 14, title: "P14" },
  { id: 15, title: "P15" },
  { id: 16, title: "P16" },
  { id: 17, title: "P17" },
  { id: 18, title: "P18" },
  { id: 19, title: "P19" },
  { id: 20, title: "P20" },
  { id: 21, title: "P21" },
  { id: 22, title: "P22" },
  { id: 23, title: "P23" },
  { id: 24, title: "P24" },
  { id: 25, title: "P25" },
  { id: 26, title: "P26" },
  { id: 27, title: "P27" },
  { id: 28, title: "P28" },
  { id: 29, title: "P29" },
  { id: 30, title: "P30" },
];

export const trollies = [
  { id: 1, title: "T1" },
  { id: 2, title: "T2" },
  { id: 3, title: "T3" },
  { id: 4, title: "T4" },
  { id: 5, title: "T5" },
  { id: 6, title: "T6" },
  { id: 7, title: "T7" },
  { id: 8, title: "T8" },
  { id: 9, title: "T9" },
  { id: 10, title: "T10" },
  { id: 11, title: "T11" },
  { id: 12, title: "T12" },
  { id: 13, title: "T13" },
  { id: 14, title: "T14" },
  { id: 15, title: "T15" },
  { id: 16, title: "T16" },
  { id: 17, title: "T17" },
  { id: 18, title: "T18" },
  { id: 19, title: "T19" },
  { id: 20, title: "T20" },
  { id: 21, title: "T21" },
  { id: 22, title: "T22" },
  { id: 23, title: "T23" },
  { id: 24, title: "T24" },
  { id: 25, title: "T25" },
  { id: 26, title: "T26" },
  { id: 27, title: "T27" },
  { id: 28, title: "T28" },
  { id: 29, title: "T29" },
  { id: 30, title: "T30" },
];

export const fuelReading = [
  { id: 1, title: "Full" },
  { id: 2, title: "Three Quarters" },
  { id: 3, title: "Half" },
  { id: 4, title: "One Quarter" },
];

export const adBlueReading = [
  { id: 1, title: "Full" },
  { id: 2, title: "Three Quarters" },
  { id: 3, title: "Half" },
  { id: 4, title: "One Quarter" },
];

export const refrigeratorReading = [
  { id: 1, title: "Full" },
  { id: 2, title: "Three Quarters" },
  { id: 3, title: "Half" },
  { id: 4, title: "One Quarter" },
];

export const washerReading = [
  { id: 1, title: "Full" },
  { id: 2, title: "Three Quarters" },
  { id: 3, title: "Half" },
  { id: 4, title: "One Quarter" },
];

export const PostponeReasons = [
  { id: 1, title: "Customer Refusal" },
  { id: 2, title: "No Access to shop" },
  { id: 3, title: "Non-Payment" },
  { id: 4, title: "Out of Hours" },
  { id: 5, title: "Traffic Incident" },
  { id: 6, title: "Customer Unavailable" },
  { id: 7, title: "Vehicle Breakdown" },
];

export const AuthByRole = [
  { id: 1, title: "Finance Manager" },
  { id: 2, title: "Account Manager" },
  { id: 3, title: "Credit Control" },
]

export const DriverTypes = [
  { id: 1, title: "Yes" },
  { id: 2, title: "No" },
]

export const CustomerOrderStatus = [
  { id: 1, title: "Received" },
  { id: 2, title: "Short" },
  { id: 3, title: "Damaged" },
  { id: 4, title: "Out Of Date" },
  { id: 5, title: "Short Dated" },
]

export const MagnaBank =
  { vat: "186 3464 79", name: "NatWest Bank", title: "Magna Foodservice Ltd", sortCode: "60-11-18", accNumber: "27672875", email: "info@magnafoodservice.co.uk", phone: "020 8050 1231" }


export const EMAIL_ENDPOINTS = {
  prod: {
    url: "https://tmsemail.api-magnafoodservice.co.uk/api/email/non-tacho-authorization",
    token: "Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAZ21haWwuY29tIiwidXNlcl9pZCI6MSwiaWF0IjoxNzI4NDE0NjIzLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6Im5vb3JAZ21haWwuY29tIn0.fb--ERLcBgLhrec6Ed_rAR_uGiBWyFdLN-4fYjjdhjw411DODxyg058A7VVQuLAgD5A8OEa-9jOar0eOTqZk3WGnP8mhh_Tx0smCmiVNY73Odn0x0KZgVyx1yf4W6nEzAHJImmXwzbnPBTIVww7CG2a47GZ8M_XQxFJNhovOnIAEoIZdFz989QdyS_8UpTVIr1UV6nbpZ01ZNuHlU-ZBxJ9zPez1bD7Q9U8Gg59AeJsr3vp6XPDuWmW0C2G3Z3YO-5jT7e1S-lFNg7_8YTH5ju7RWlvdjOJ8lGIiQAVF4aRMXIJh3HHPYBdUWugj7Zb0ZF8F4rz8sR4zNgqEUXJtPQ"
  },
  dev: {
    url: "http://localhost:7420/api/email/non-tacho-authorization",
    token: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluQG1hZ25hZm9vZHNlcnZpY2UuY28udWsiLCJ1c2VyX2lkIjoyNCwiaWF0IjoxNzcyNzk5OTYwLCJhdWQiOiJodHRwczovL3d3dy5tYWduYWZvb2RzZXJ2aWNlLmNvLnVrLyIsImlzcyI6Ik1hZ25hIEZvb2QgU2VydmljZSIsInN1YiI6ImFkbWluQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.UWsRirxEJ3XyqktFlf_IqVkJQ80I124XgxZjLmm4UCo5vYxppfa3QOqp-fu0lnhy19yDlT4qG9BBB3NRvpsySyZvT5RP8WrF23I1Zy0mTvBn1ra01FUKJdC7O_ReHQ224r16Pnx7kH3ASp4UrL5d0Lun_fxEpxc--rCDiTkoW8LlcBo4S8BCqeY21IDDgf9T5bfhKxzajmUVLHj-O-F8r3JUfqJCDQMAqApYb18ttIFvYlhvgu_gmnILEs7J7KhNmT8bMuKrppztlIwtEUuBBx3w8gRVtpB8_LUhrNh164MlGoWLN4Oo06srjOzzhoKIN6allOBNCDgm2Wg6zsTpkg"
  },
  uat: {
    url: "http://34.197.161.10:7420/api/email/non-tacho-authorization",
    token: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6Im5vb3JAbWFnbmFmb29kc2VydmljZS5jby51ayIsInVzZXJfaWQiOjEsImlhdCI6MTczNTU1OTM3NywiYXVkIjoiaHR0cHM6Ly93d3cubWFnbmFmb29kc2VydmljZS5jby51ay8iLCJpc3MiOiJNYWduYSBGb29kIFNlcnZpY2UiLCJzdWIiOiJub29yQG1hZ25hZm9vZHNlcnZpY2UuY28udWsifQ.ZC9_oBo2jQAz9EKCn19KD17WzMaVQPjuUUWhSBfDPPnaqb18j4cILaJIJUYgVprjjAGIzxUBt4Ln7do3br5Ps1nzkShjVrptne_eop_rxqcJCHnaIlra0UQnFsiTBJ8V_5GanQAQIVbuKwFlcpqJCb5adCeE5OipBANSURekGyMXSeYos4dVjrZu7g7DD8sxCWkePVW_LhlndbytgdkazRmOkHNmnq5x9bnO16fMAAPm1nMVxluC5bGJzJqCYhmnO-UlV6ZpAdCACS0ZW7tylwc2foEtkLz7jUE8X7hHUGCYfRO2N7gMcqKqBYgbf6DV5HEgsDFoEoGlxGjERqGjCQ"
  }
};